import { render, staticRenderFns } from "./S4cAging.vue?vue&type=template&id=083e384a"
import script from "./S4cAging.vue?vue&type=script&lang=ts"
export * from "./S4cAging.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports